import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, iraDataAtom } from '../ira_list_atoms';
import { IraDataHook } from '../../ira_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useIraData = (): IraDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(iraDataAtom);

    const { items } = useTableData({ view, filters, stats, data, setStats });

    return { items };
};
